/*
 * Constants.
 */

const conversationIdCustomEventKey = 'companion-conversation-id';

/*
 * API.
 */

export function dispatchConversationIdCustomEvent(conversationId: string | undefined) {
  window.dispatchEvent(new CustomEvent(conversationIdCustomEventKey, {detail: {conversationId}}));
}
